/**
 * Main product: store product ID in localStorage for recently viewed products section.
 * Expects a container with data-product-id (e.g. on .shopify-section--main-product or inner wrapper).
 */
(function () {
  function run() {
    const el = document.querySelector('.shopify-section--main-product [data-product-id]') ||
               document.querySelector('.shopify-section--main-product');
    const productId = el && el.getAttribute && el.getAttribute('data-product-id');
    if (productId == null || productId === '') return;

    try {
      var stored = JSON.parse(localStorage.getItem('theme:recently-viewed-products') || '[]');
      var idStr = String(productId);
      stored = stored.filter(function (item) { return String(item) !== idStr; });
      stored.unshift(idStr);
      localStorage.setItem('theme:recently-viewed-products', JSON.stringify(stored));
    } catch (e) {
      // Safari private mode etc.
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
